import { useCallback, useContext } from 'react';

import type { Keys } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

const useKeys = () => {
  const { sendRequest } = useContext(MessagingContext)!;
  const getKey = useCallback(async () => {
    const { result, error } = await sendRequest<Keys>('keys', {});
    return { result, error };
  }, [sendRequest]);

  return getKey;
};

export default useKeys;
